import agent from "../../../api/agent";
export const list = (pagerInputModel) =>
  agent.requests.post(`/country/GetCustomPagedList`, pagerInputModel);
export const create = (country) => agent.requests.post(`/country/create`, country);
export const update = (country) => agent.requests.post(`country/update`, country);
